import {
  blue,
  grey,
  red,
  brown,
  lime,
  lightGreen,
  green,
  orange,
  yellow
} from '@material-ui/core/colors'
// import blue from 'maerial-ui/colors/blue'
// import grey from '@material-ui/core/colors/grey'
// import red from '@material-ui/core/colors/red'
// import brown from '@material-ui/core/colors/brown'
// import lime from '@material-ui/core/colors/lime'
// import lightGreen from '@material-ui/core/colors/lightGreen'
// import green from '@material-ui/core/colors/green'

// export const landCoverMetadata = [
//   {
//     key: 'GRIDCODE',
//     value: 20,
//     label: 'Water',
//     color: blue[500]
//   },
//   {
//     key: 'GRIDCODE',
//     value: 31,
//     label: 'Snow/Ice',
//     color: blue[50]
//   },
//   {
//     key: 'GRIDCODE',
//     value: 32,
//     label: 'Rock/Rubble',
//     color: grey[300]
//   },
//   {
//     key: 'GRIDCODE',
//     value: 33,
//     label: 'Exposed land',
//     color: grey[500]
//   },
//   {
//     key: 'GRIDCODE',
//     value: 34,
//     label: 'Developed',
//     color: red[500]
//   },
//   {
//     key: 'GRIDCODE',
//     value: 50,
//     label: 'Shrubland',
//     color: lime[900]
//   },
//   {
//     key: 'GRIDCODE',
//     value: 110,
//     label: 'Grassland',
//     color: lightGreen[500]
//   },
//   {
//     key: 'GRIDCODE',
//     value: 120,
//     label: 'Agriculture',
//     color: orange['A200']
//   },
//   {
//     key: 'GRIDCODE',
//     value: 210,
//     label: 'Coniferous Forest',
//     color: green[900]
//   },
//   {
//     key: 'GRIDCODE',
//     value: 220,
//     label: 'Broadleaf Forest',
//     color: green[500]
//   },
//   {
//     key: 'GRIDCODE',
//     value: 230,
//     label: 'Mixed Forest',
//     color: lightGreen[700]
//   }
// ]
export const cropInventoryMetadata = [
  {
    key: 'GRIDCODE',
    value: 0,
    label: 'Water',
    color: blue[500]
  },
  {
    key: 'GRIDCODE',
    value: 1,
    label: 'Water',
    color: blue[500]
  },
  {
    key: 'GRIDCODE',
    value: 2,
    label: 'Grassland',
    color: lightGreen[500]
  },
  {
    key: 'GRIDCODE',
    value: 3,
    label: 'Forest',
    color: green[500]
  },
  {
    key: 'GRIDCODE',
    value: 4,
    label: 'Developed',
    color: yellow[500]
  },
  {
    key: 'GRIDCODE',
    value: 5,
    label: 'Shrubland',
    color: lime[900]
  },
  {
    key: 'GRIDCODE',
    value: 110,
    label: 'Grassland',
    color: lightGreen[500]
  },
  {
    key: 'GRIDCODE',
    value: 122,
    label: 'Agriculture',
    color: orange['A200']
  },
  {
    key: 'GRIDCODE',
    value: 210,
    label: 'Coniferous Forest',
    color: green[900]
  },
  {
    key: 'GRIDCODE',
    value: 220,
    label: 'Broadleaf Forest',
    color: green[500]
  },
  {
    key: 'GRIDCODE',
    value: 230,
    label: 'Mixed Forest',
    color: lightGreen[700]
  }
]



// WEBPACK FOOTER //
// ./src/config/cropInventory.js